/**
 * Bygger en GeoJSON-kompatibel polygon av en cirkel.
 * @param {number} lng - Longitud i grader
 * @param {number} lat - Latitud i grader
 * @param {number} radius - Radie i meter
 * @param {number} z - Höjd (valfritt, ignoreras oftast)
 * @param {number} steps - Antal punkter (default 72, ett var 5:e grad)
 * @returns {Array} GeoJSON Polygon coordinates: [ [ [lng, lat, z], ... ] ]
 */
export function circleToPolygon(lng, lat, radius, z = 0, steps = 72) {
  const coords = [];
  const earthRadius = 6378137;
  const radLat = lat * Math.PI / 180;
  for (let i = 0; i < steps; i++) {
    const angle = (i / steps) * 2 * Math.PI;
    const dx = (radius * Math.cos(angle)) / (earthRadius * Math.cos(radLat)) * (180 / Math.PI);
    const dy = (radius * Math.sin(angle)) / earthRadius * (180 / Math.PI);
    coords.push([lng + dx, lat + dy, z]);
  }
  // Slut polygonen (första = sista punkt)
  coords.push(coords[0]);
  return [coords]; // GeoJSON Polygon: coordinates: [ [ [lng, lat, z], ... ] ]
}